
	export default { name: 'VLegend' } // name the component
